import React, { Component } from 'react';
import { Button, Modal, Icon, Input, Select, Form, message } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';

import { putExchange, getExchange } from '../../common/fetch';
import { ExchangeAction } from '../../actions';
import SEOSuccessModal from './SEOSuccessModal';
import { DomainWrapper as DomainSeoWrapper } from './style';
import { DashLinksToolTip } from './Utils';

const { TextArea } = Input;

class SEOSetup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            width: 750,
            isSEOSave: false,
            isDisable: true
        }
    }

    handleClose = () => {
        this.setState({ isSEOSave: false });
    };

    handleWidth = (value) => {
        this.setState({ width: value });
    };

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            this.props.storeExchange(exchange);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleSEO = () => {
        this.setState({ isSEOSave: !this.state.isSEOSave, isDisable: true });
    };

    updateSEO = async (formValues) => {
        const { exchange: { id } } = this.props;
        const body = { info: { html: formValues }, id }
        try {
            await putExchange(body);
            this.getExchange();
            this.handleSEO();
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleSubmit = (e) => {
        e.preventDefault()
        const { getFieldsValue } = this.props.form;
        let formValues = getFieldsValue()
        const { keywords } = formValues;
        formValues = { ...formValues, keywords: keywords.toString() }
        this.updateSEO(formValues)
    };

    handleInitialValue = (keywords) => {
        let data = keywords.split(",")
        if (keywords && data.length) {
            return data
        }
    }

    handleChangeValue = (e) => {
        this.setState({ isDisable: false });
    }

    render() {
        const { width, isAdvanced, isSEOSave, isDisable } = this.state;
        const { exchange, form } = this.props;
        const { getFieldDecorator } = form;

        const title = _get(exchange, "info.html.title", "")
        const keywords = _get(exchange, "info.html.keywords", "")
        const description = _get(exchange, "info.html.description", "")
        const head = _get(exchange, "info.html.head", "")
        const body = _get(exchange, "info.html.body", "")

        return (
            <DomainSeoWrapper>
                <div className="seo-container">
                    <div className="title-container">
                        <div className='d-flex'>
                            <div className="main-title">
                                SEO settings
                        </div>
                            <div className='seo-dash-link'>
                                <DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=K0bK4b8WblY'}/>
                            </div>
                        </div>
                        <div className="content">
                            Specify title, description and keywords to be used in search engines and title of browser.
                        </div>
                    </div>
                <div className='seo-form-wrapper'>
                    <Form name="seo-form" onSubmit={this.handleSubmit} onChange={this.handleChangeValue}>
                        <div className="input-container">
                            <div className="bold">
                                Title tag
                            </div>
                            <div className="info-text">
                                Write a title using around 55 characters.
                            </div>
                            {getFieldDecorator('title', {
                                initialValue: title
                            })(<Input
                                className="input"
                                placeholder="Title"
                            />)}
                        </div>
                        <div className="input-container">
                            <div className="bold">
                                Meta Description
                            </div>
                            <div className="info-text">
                                Write a description and use keywords with around 155 to 300 characters.
                            </div>
                                {getFieldDecorator('description', {
                                    initialValue: description
                                })(<TextArea
                                    className="input"
                                    placeholder="Description"
                                />)}

                            </div>
                            <div className="input-container">
                                <div className="bold">
                                    Keywords
                            </div>
                                <div className="info-text">
                                    Add keywords and press 'enter' key or separate words with a comma
                            </div>
                                <div>
                                    {getFieldDecorator('keywords', {
                                        initialValue: this.handleInitialValue(keywords)
                                    })(<Select
                                        mode="tags"
                                        placeholder="Exchange, coins name, trade, market"
                                        className="input"
                                        dropdownClassName="hide-dropdown"
                                        dropdownStyle={{ display: "none" }}
                                        onChange={this.handleChangeValue}
                                        tokenSeparators={[',', ' ']}
                                    />)}
                                </div>
                            </div>
                            <div
                                className="bold pointer"
                                onClick={() => this.setState({ isAdvanced: !isAdvanced })}
                            >
                                Show advanced
                            <Icon className="down-icon" type={isAdvanced ? "caret-up" : "caret-down"} style={{ color: "#ffffff" }} />
                            </div>
                            {isAdvanced ?
                                <div>
                                    <div className="title-container">
                                        <div className="main-title">
                                            Custom code
                                    </div>
                                    </div>
                                    <div className="bold mt-1">
                                        {`Inside <head> tag`}
                                    </div>
                                    {getFieldDecorator('head', {
                                        initialValue: head
                                    })(<TextArea
                                        className="html-text-area"
                                        spellCheck="false"
                                    />)}
                                    <div className="bold mt-1">
                                        {`Before </body> tag`}
                                    </div>
                                    {getFieldDecorator('body', {
                                        initialValue: body
                                    })(<TextArea
                                        className="html-text-area"
                                        spellCheck="false"
                                    />)}
                                </div>
                                :
                                null
                            }
                            <Button
                                type="primary"
                                className="mt-1 save-btn"
                                htmlType="submit"
                                disabled={isDisable}
                            >
                                Save
                        </Button>
                        </Form>
                        <div className="info-text mt-1">
                            <Icon className="warn-icon" type="exclamation-circle" />
                        After saving you'll be required to upgrade to apply changes in the <Link to="/hosting?tab=3">Manage section</Link>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={isSEOSave}
                    footer={null}
                    width={`${width}px`}
                    onCancel={this.handleClose}
                >
                    <SEOSuccessModal
                        history={this.props.history}
                        handleWidth={this.handleWidth}
                        onCancel={this.handleSEO}
                    />
                </Modal>
            </DomainSeoWrapper>
        )
    }
}

const SEOForm = Form.create()(SEOSetup);

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
});

const mapDispatchToProps = (dispatch) => ({
    storeExchange: bindActionCreators(ExchangeAction.readData, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SEOForm);



